module.exports = __WEBPACK_EXTERNAL_MODULE_27__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/geom/Vector3D","root":["openfl","geom","Vector3D"],"commonjs":"openfl/geom/Vector3D","commonjs2":"openfl/geom/Vector3D"}
// module id = 27
// module chunks = 0